import { useEffect } from 'react';
import { setCachedFilters } from '@atlassian/jira-filters-storage/src/index.tsx';
import { useBoardSelector } from '../../state/index.tsx';
import { rapidViewIdSelector } from '../../state/selectors/software/software-selectors.tsx';
import { useIsCMPBoard } from '../../state/state-hooks/capabilities/index.tsx';

export const FiltersStorage = () => {
	const isCMPBoard = useIsCMPBoard();
	const boardId = useBoardSelector(rapidViewIdSelector);
	const filters = useBoardSelector((state) => state.ui.workFilters?.values);

	useEffect(() => {
		if (isCMPBoard) {
			setCachedFilters('board', boardId, filters);
		}
	}, [boardId, filters, isCMPBoard]);

	return null;
};
